module.exports = __webpack_public_path__ + "img/airbase-stage_1.3.4ff2795c.jpg";